var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 64,
    viewBox: "0 0 304 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4707 54.9892C43.3577 47.8552 43.8996 33.8906 35.5229 22.8136C38.3419 29.9352 37.6931 40.5437 33.8364 49.5246L38.4707 54.9892Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1803_25288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 64
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.129395H80.8652V63.6117H0V0.129395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1803_25288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3743 56.9273C72.6125 45.2487 74.248 21.4671 52.1823 0.129395C61.9466 15.4749 66.2552 35.1506 58.5177 56.5402C56.8603 56.5229 52.9114 56.5994 50.3111 56.7325C56.7315 48.2324 58.9891 31.8709 44.8433 9.83779C48.5566 22.8801 50.192 34.3393 44.7315 48.9747L50.1896 56.7399C33.3342 57.6129 11.1616 61.0824 0 62.816L1.65006 63.6125C9.17134 62.5694 51.8761 56.407 76.7194 61.2107L80.8652 59.1393C78.1386 58.148 73.7668 57.3515 68.3743 56.9273Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.356 20.1569H192.385V49.3585L167.778 20.1569H162.004C162.859 20.5662 164.106 21.7499 164.106 23.333V57.1163H166.079V24.7213L193.068 57.1163H194.356V20.1569Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.684 20.1578V49.3595L242.076 20.1578H236.3C237.153 20.5672 238.399 21.7508 238.399 23.334V57.1173H240.373V24.7223L267.362 57.1173H268.652V22.2983C270.922 22.0541 276.431 21.6448 282.582 21.6448V57.1173H287.138V21.6448C295.962 21.6448 302.339 22.4142 302.339 22.4142L303.092 20.1578H266.684Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.453 19.7144C128.01 19.7144 121.947 28.1849 121.947 38.6355C121.947 49.0861 127.955 57.5566 140.453 57.5566C152.951 57.5566 158.958 49.0861 158.958 38.6355C158.958 28.1849 152.895 19.7144 140.453 19.7144ZM140.761 56.1233C131.468 56.1233 126.863 48.2939 126.693 38.6398C126.523 28.9856 130.819 21.1587 140.144 21.1587C149.473 21.1587 154.039 28.9856 154.209 38.6398C154.377 48.2939 150.049 56.1233 140.761 56.1233Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0513 20.1587C89.9042 20.5681 91.1509 21.7517 91.1509 23.3349V57.1182H95.7098V22.0156C97.6005 21.7419 101.384 21.5249 103.958 21.6654C106.237 21.7887 109.027 22.457 110.811 23.7417C112.974 25.2977 114.179 27.5245 114.249 30.5798C114.534 43.1709 102.189 42.4705 97.1436 40.991V42.8848C101.207 43.5161 110.225 44.1992 115.963 38.6878C118.108 36.6287 119.134 33.4255 118.937 30.3652C118.684 26.4493 116.249 22.785 109.89 21.0169C106.4 20.0453 102.653 20.1587 97.3235 20.1587H89.0513Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.279 57.1239H235.358L216.352 20.1644H214.194L197.358 57.1239H199.53L205.504 44.0002H223.411L230.279 57.1239ZM206.3 42.2262L213.833 25.6723L222.48 42.2262H206.3Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dfe282463e5105eec13bbd38da442c74.svg";
export { ForwardRef as ReactComponent };